module.exports = {
  STATUS: {
    FAILED: 'FAILED',
    OPEN: 'OPEN',
    IN_REVIEW: 'IN_REVIEW',
    CLOSED: 'CLOSED'
  }
};
